<template>
  <div class="lib__form__main">
    <ValidationObserver ref="validator" slim>
      <h2 class="lib__h2 lib__text-center">{{ $t('new-connection-cmh.email-registration.yourNewConnection') }}</h2>
      <p class="lib__text-center step-top-paragraph" v-html="$t('new-connection-cmh.email-registration.topParagraph')"></p>
      <div class="col-sm-6 col-sm-offset-3 col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 mobile-textbox-container">
        <text-box :label="$t('contact.form.email')" email required v-model="emailAddress"></text-box>
      </div>
      <div class="lib__text-center btn-container col-xs-12 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3">
        <a @click="handleNext" class="lib__btn--full lib__btn lib__btn--primary lib__btn--rounded">
          {{ $t('new-connection-cmh.email-registration.hereWeGo') }}
        </a>
      </div>
      <faq-display @link-click="tagClick('bouton_faq', $event)"/>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { Form } from '@/views/forms/Form'
import Step from '@/components/steps/Step'
import { State, Mutation } from 'vuex-class'
import { validation } from '@ores/vue-library'
import FaqDisplay from '@/components/display/FaqDisplay.vue'
import { pixelFacebookService } from '@ores/vue-library'
import { StepMailRegistration } from '@/models'
import { newConnectionCmhGtmService as gtmService, GtmEventType } from '@/services/gtm'

@Component({
  components: {
    FaqDisplay
  },
  name: 'cmh-email-registration-step'
})
export default class CmhEmailRegistrationStep extends Step {
  //#region [Data]
  public emailAddress: string = ''

  @State('requestId', { namespace: 'newConnectionCmh' })
  public requestId!: string
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'newConnectionCmh/mailRegistration' })
  private store!: (index: string) => void
  //#endregion

  //#region [Method]
  public mounted() {
    pixelFacebookService.trackViewContent({
      content_ids: ['CmhForm'],
      content_name: 'Email Registration Step',
      content_type: 'product'
    })
  }

  public async save(next: boolean, isValid: boolean): Promise<boolean | void> {
    if (isValid) {
      this.store(this.emailAddress)

      const data: StepMailRegistration = {
        email: this.emailAddress,
        requestId: this.requestId,
        language: this.$i18n.locale
      }

      this.$api.post<StepMailRegistration>('NewConnectionRequest/store/mail-registration', data)

      this.$appInsights.trackEvent('WR_NCCMH_Step0_Validated', { Segment: 'WR_NCCMH', WebRef: this.requestId })
    }
  }

  async handleNext(){
    this.tagClick('bouton_allons-y')
    await this.next()     
  }

  tagClick(name: string, url: string | null = null) {
    gtmService.sendGtmEvent({ 
      eventType: GtmEventType.body_button_click,
      step: 0,
      ctaName: name,
      linkUrl: url,
      language: this.$i18n.locale
    })
  }
  //#endregion
}
</script>

<style scoped>
@media screen and (min-width: 577px) {
  .step-top-paragraph {
    height: 60px;
    width: 450px;
    font-size: 15px;
    letter-spacing: 0;
    line-height: 20px;
    margin: auto auto 20px;
  }
  .btn-container {
    margin-top: 32px;
  }
}

@media screen and (max-width: 576px) {
  .step-top-paragraph {
    width: 90%;
    font-size: 15px;
    letter-spacing: 0;
    line-height: 20px;
    margin: 20px auto 32px;
  }
  .mobile-textbox-container {
    margin: 0px auto 40px;
  }
}
</style>
